export class CreatePaymentModel {
    email: string;
    borrowTypeCode: string;
    language: string;
}